import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

// --- 1. INTERFACES ---
interface QA {
  question: string;
  answer: string;
  type: 'rating' | 'text' | 'choice';
}

interface FeedbackItem {
  id: number;
  user: string;
  email: string;
  date: string;
  examName: string;
  // overallRating dihapus
  status: 'New' | 'Read';
  answers: QA[];
}

// --- 2. HELPERS ---
const getAvatarColor = (name: string) => {
  const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD', '#D4A5A5', '#9B59B6'];
  let hash = 0;
  for (let i = 0; i < name.length; i++) { hash = name.charCodeAt(i) + ((hash << 5) - hash); }
  return colors[Math.abs(hash) % colors.length];
};

const getInitials = (name: string) => {
  return name.split(' ').map((n) => n[0]).join('').substring(0, 2).toUpperCase();
};

// Fungsi renderStars dihapus karena tidak lagi digunakan di tabel

// --- 3. CSS STYLES (RED & WHITE THEME + GRID LAYOUT) ---
const feedbackStyles = `
  :root {
    --bg-soft: #f4f7f6;
    --text-dark: #2d3436;
    --text-muted: #636e72;
    --brand-red: #e53935;
    --brand-red-dark: #c62828;
    --brand-red-light: #ffebee;
    --gold: #f1c40f;
  }

  /* --- Styles Tabel Utama --- */
  .feedback-container { padding: 20px; background: var(--bg-soft); border-radius: 20px; min-height: 400px; font-family: 'Poppins', sans-serif; }
  .fb-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
  .title-group h3 { font-size: 1.8rem; font-weight: 800; color: var(--text-dark); margin: 0; }
  .title-group span { font-size: 0.9rem; color: var(--text-muted); font-weight: 500; }
  .glass-search { background: white; border-radius: 50px; padding: 8px 20px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); border: 1px solid rgba(0,0,0,0.02); display: flex; align-items: center; width: 280px; transition: all 0.3s ease; }
  .glass-search:focus-within { box-shadow: 0 4px 20px rgba(229, 57, 53, 0.15); border-color: #ffcdd2; }
  .glass-search input { border: none; outline: none; width: 100%; font-size: 0.95rem; background: transparent; color: var(--text-dark); }
  .table-wrapper { overflow-x: auto; scrollbar-width: none; }
  .table-wrapper::-webkit-scrollbar { display: none; }
  .modern-table { width: 100%; border-collapse: separate; border-spacing: 0 15px; }
  .modern-table thead th { font-size: 0.85rem; text-transform: uppercase; letter-spacing: 1px; color: #b2bec3; font-weight: 700; padding: 0 20px 10px 20px; text-align: left; }
  .fb-row td { background: white; padding: 20px; vertical-align: middle; border-top: 1px solid rgba(0,0,0,0.01); border-bottom: 1px solid rgba(0,0,0,0.01); }
  .fb-row td:first-child { border-top-left-radius: 16px; border-bottom-left-radius: 16px; }
  .fb-row td:last-child { border-top-right-radius: 16px; border-bottom-right-radius: 16px; }
  .fb-row:hover td { transform: scale(1.005); cursor: default; }
  .fb-row:hover { filter: drop-shadow(0 10px 20px rgba(0,0,0,0.05)); }
  .user-group { display: flex; align-items: center; gap: 12px; }
  .avatar { width: 40px; height: 40px; border-radius: 12px; color: white; font-weight: 700; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
  .exam-badge { background: #ffebee; color: #c62828; padding: 5px 12px; border-radius: 20px; font-size: 0.75rem; font-weight: 700; display: inline-block; border: 1px solid #ffcdd2; }
  
  /* .star-group style dihapus */
  
  .status-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 6px; }
  .st-new { color: #e53935; font-weight: 700; } 
  .st-read { color: #00b894; font-weight: 700; }
  .action-btn { width: 36px; height: 36px; border-radius: 10px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: 0.2s; font-size: 0.9rem; }
  .btn-view { background: #ffebee; color: #c62828; }
  .btn-view:hover { background: #e53935; color: white; transform: translateY(-2px); }
  .btn-del { background: #f5f5f5; color: #636e72; }
  .btn-del:hover { background: #2d3436; color: white; transform: translateY(-2px); }

  /* --- STYLE MODAL MERAH PUTIH (RED & WHITE THEME) --- */
  .modal-header-red {
    background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);
    padding: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    color: white;
    border-radius: 10px 10px 0 0;
    position: relative;
    overflow: hidden;
  }
  
  .modal-header-red::after {
    content: ''; position: absolute; top: 0; right: 0; bottom: 0; left: 0;
    background: url('https://www.transparenttextures.com/patterns/cubes.png');
    opacity: 0.1;
  }

  .modal-avatar-large {
    width: 60px; height: 60px; border-radius: 50%;
    background: white; color: var(--brand-red);
    font-size: 1.5rem; font-weight: 800;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
    z-index: 2;
  }

  .modal-user-details { z-index: 2; text-align: left; }
  .modal-user-details h3 { margin: 0; font-size: 1.4rem; font-weight: 700; }
  .modal-user-details p { margin: 0; font-size: 0.9rem; opacity: 0.9; margin-top: 4px; }

  /* Container Grid */
  .qna-grid-container {
    max-height: 500px;
    overflow-y: auto;
    padding: 25px;
    background: #f9fafb;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }

  /* Kartu Jawaban */
  .qna-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-left: 5px solid var(--brand-red);
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    transition: transform 0.2s;
  }
  .qna-card:hover { transform: translateY(-3px); box-shadow: 0 5px 15px rgba(229, 57, 53, 0.1); }

  .q-label {
    font-size: 0.75rem; font-weight: 700; color: #b0bec5;
    text-transform: uppercase; margin-bottom: 8px;
    display: flex; justify-content: space-between;
  }
  .q-badge {
    background: var(--brand-red-light); color: var(--brand-red);
    padding: 2px 8px; border-radius: 4px;
  }

  .q-text { font-size: 0.9rem; font-weight: 700; color: #2d3436; margin-bottom: 8px; line-height: 1.4; }
  
  .a-box {
    margin-top: auto;
    background: #fdfdfd;
    padding: 10px;
    border-radius: 6px;
    border: 1px dashed #e0e0e0;
    font-size: 0.9rem; color: #546e7a;
  }
  
  .a-rating { color: var(--gold); font-weight: bold; display: flex; align-items: center; gap: 5px; }

  .qna-grid-container::-webkit-scrollbar { width: 8px; }
  .qna-grid-container::-webkit-scrollbar-track { background: #f1f1f1; }
  .qna-grid-container::-webkit-scrollbar-thumb { background: #cfd8dc; border-radius: 4px; }
`;

const FeedbackContent: React.FC = () => {
  // --- DUMMY DATA (Overall Rating Removed) ---
  const [feedbacks, setFeedbacks] = useState<FeedbackItem[]>([
    { 
      id: 1, 
      user: 'Maria Garcia', 
      email: 'maria@email.com', 
      date: '12 Jan 2026', 
      examName: 'Basic English Assessment',
      status: 'New',
      answers: [
        { question: 'Apakah instruksi jelas?', answer: 'Sangat Jelas', type: 'choice' },
        { question: 'Tingkat kesulitan?', answer: 'Sedang', type: 'choice' },
        { question: 'Waktu pengerjaan cukup?', answer: 'Cukup, tapi agak mepet di bagian reading.', type: 'text' },
        { question: 'Kendala teknis?', answer: 'Tidak ada.', type: 'text' },
        { question: 'Materi relevan?', answer: 'Sangat Relevan', type: 'rating' },
        { question: 'Kualitas audio?', answer: 'Jernih, tidak ada noise.', type: 'text' },
        { question: 'Tampilan antarmuka?', answer: 'User Friendly.', type: 'text' },
        { question: 'Saran soal baru?', answer: 'Perbanyak conversation.', type: 'text' },
        { question: 'Bagian tersulit?', answer: 'Grammar Section B', type: 'text' },
        { question: 'Kepuasan total?', answer: '4/5 (Puas)', type: 'rating' },
      ]
    },
    { 
      id: 2, 
      user: 'Budi Santoso', 
      email: 'budi@indo.com', 
      date: '10 Jan 2026', 
      examName: 'TOEFL Preparation',
      status: 'Read',
      answers: [
        { question: 'Apakah instruksi jelas?', answer: 'Jelas', type: 'choice' },
        { question: 'Tingkat kesulitan?', answer: 'Sulit', type: 'choice' },
        { question: 'Waktu pengerjaan cukup?', answer: 'Sangat Cukup', type: 'text' },
        { question: 'Kendala teknis?', answer: 'Loading lama di no 5.', type: 'text' },
        { question: 'Materi relevan?', answer: 'Relevan', type: 'rating' },
        { question: 'Kualitas audio?', answer: 'Suara kecil.', type: 'text' },
        { question: 'Tampilan antarmuka?', answer: 'Modern.', type: 'text' },
        { question: 'Saran soal baru?', answer: 'Tidak ada.', type: 'text' },
        { question: 'Bagian tersulit?', answer: 'Listening', type: 'text' },
        { question: 'Kepuasan total?', answer: '5/5 (Sangat Puas)', type: 'rating' },
      ]
    },
  ]);

  const [searchQuery, setSearchQuery] = useState('');

  // --- LOGIC: MODAL GRID 2 KOLOM (RED & WHITE) ---
  const handleViewDetail = (item: FeedbackItem) => {
    
    // Generate Cards untuk Grid
    const qnaHTML = item.answers.map((qa, index) => {
        let answerContent = qa.answer;
        
        // Custom format untuk tipe soal 'rating' di dalam detail jawaban (tetap dipertahankan)
        if (qa.type === 'rating') {
            answerContent = `<span class="a-rating"><i class="fas fa-star"></i> ${qa.answer}</span>`;
        }

        return `
        <div class="qna-card">
            <div class="q-label">
                <span>Question</span>
                <span class="q-badge">#${index + 1}</span>
            </div>
            <div class="q-text">${qa.question}</div>
            <div class="a-box">${answerContent}</div>
        </div>
        `;
    }).join('');

    // Initials
    const initials = getInitials(item.user);

    MySwal.fire({
      title: '', 
      html: `
        <div class="modal-header-red">
           <div class="modal-avatar-large">${initials}</div>
           <div class="modal-user-details">
              <h3>${item.user}</h3>
              <p>${item.examName} &nbsp;•&nbsp; ${item.date}</p>
           </div>
        </div>
        
        <div class="qna-grid-container">
           ${qnaHTML}
        </div>
      `,
      width: 850,
      padding: 0,
      showCancelButton: true,
      confirmButtonText: 'Tandai Dibaca',
      confirmButtonColor: '#e53935',
      cancelButtonText: 'Tutup',
      cancelButtonColor: '#95a5a6',
      focusConfirm: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setFeedbacks(feedbacks.map(f => f.id === item.id ? { ...f, status: 'Read' } : f));
        MySwal.fire({ 
            icon: 'success', 
            title: 'Updated', 
            text: 'Status feedback diperbarui.', 
            confirmButtonColor: '#e53935', 
            timer: 1500,
            showConfirmButton: false
        });
      }
    });
  };

  const handleDelete = (id: number) => {
    MySwal.fire({
       title: 'Hapus Data?', text: "Data ini akan dihapus permanen.", icon: 'warning', 
       showCancelButton: true, confirmButtonColor: '#e53935', confirmButtonText: 'Ya, Hapus'
    }).then((res) => {
       if(res.isConfirmed) setFeedbacks(feedbacks.filter(f => f.id !== id));
    });
  };

  const filteredData = feedbacks.filter(f => 
    f.user.toLowerCase().includes(searchQuery.toLowerCase()) || 
    f.examName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <style>{feedbackStyles}</style>
      <div className="feedback-container">
        
        <div className="fb-header">
          <div className="title-group">
             <h3>Assessment Feedback</h3>
             <span>Survey kepuasan user pasca-ujian (10 Poin).</span>
          </div>
          <div className="glass-search">
             <i className="fas fa-search" style={{color:'#b2bec3', marginRight:'8px'}}></i>
             <input type="text" placeholder="Cari user atau ujian..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
          </div>
        </div>

        <div className="table-wrapper">
          <table className="modern-table">
            <thead>
              {/* Kolom Rating Dihapus */}
              <tr><th>User</th><th>Tanggal</th><th>Assessment</th><th>Status</th><th>Lihat Hasil</th></tr>
            </thead>
            <tbody>
              {filteredData.map((item) => (
                <tr key={item.id} className="fb-row">
                  <td>
                    <div className="user-group">
                       <div className="avatar" style={{background: getAvatarColor(item.user)}}>{getInitials(item.user)}</div>
                       <div><div style={{fontWeight:'bold', fontSize:'0.95rem'}}>{item.user}</div><div style={{fontSize:'0.75rem', color:'#b2bec3'}}>{item.email}</div></div>
                    </div>
                  </td>
                  <td><span style={{fontSize:'0.85rem', color:'#636e72'}}>{item.date}</span></td>
                  <td><span className="exam-badge">{item.examName}</span></td>
                  
                  {/* Kolom Rating Bintang di sini telah dihapus */}
                  
                  <td>
                    <div className={item.status === 'New' ? 'st-new' : 'st-read'}>
                        <span className="status-dot" style={{background: item.status === 'New' ? '#e53935' : '#00b894'}}></span>
                        {item.status === 'New' ? 'Baru' : 'Dibaca'}
                    </div>
                  </td>
                  <td>
                    <div style={{display:'flex', gap:'8px'}}>
                        <button className="action-btn btn-view" onClick={() => handleViewDetail(item)} title="Lihat Jawaban"><i className="fas fa-eye"></i></button>
                        <button className="action-btn btn-del" onClick={() => handleDelete(item.id)} title="Hapus"><i className="fas fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
              ))}
              {/* Colspan disesuaikan menjadi 5 */}
              {filteredData.length === 0 && <tr><td colSpan={5} style={{textAlign:'center', padding:'30px', color:'#b2bec3'}}>Tidak ada data feedback.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FeedbackContent;